import { jsx as _jsx } from "react/jsx-runtime";
import { Progress as HeroProgress } from '@heroui/react';
export const Progress = (props) => {
    return _jsx(HeroProgress, { ...props });
};
export default Progress;
//# sourceMappingURL=Progress.js.map